import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { ALL_CLIENTS_KEY, useOrgStore } from "../stores/org.store";



export const useClientProfile = () => {
  const activeClientId = useOrgStore((s) => s.activeClientId);
  const isAllProsMode = activeClientId === ALL_CLIENTS_KEY;

  return useQuery({
    queryKey: ["client-profile", activeClientId],
    queryFn: async () => {
      const endpoint = isAllProsMode
        ? "/portal/aggregate/me"
        : "/portal/me";
      const { data } = await api.get(endpoint);
      return data;
    },
    staleTime: 15_000,
    retry: false,
  });
}
